export type FormaLanguage = 'en' | 'pl';

/** A saved choice wins; only the primary device/browser language supplies a default. */
export function resolveLanguage(
  preferredLanguage: unknown,
  deviceLanguages?: readonly string[] | string,
): FormaLanguage {
  if (preferredLanguage === 'pl' || preferredLanguage === 'en')
    return preferredLanguage;
  const primary =
    typeof deviceLanguages === 'string'
      ? deviceLanguages
      : deviceLanguages?.[0];
  return primary?.trim().toLowerCase().split(/[-_]/)[0] === 'pl' ? 'pl' : 'en';
}
